export enum ActionEnum {
    LOTTERY_UPDATE_WINNER_CONFIG,
    LOTTERY_END_LOTTERY_CYCLE,
    LOTTERY_UPDATE_BASE_CONFIG,
    LOTTERY_GIVE_AWAY_TICKET
}